import { getLocalStorageLocale } from '@futrli/localisation';

import { formulaFuncLangMap } from './const';

const formulaLangMap = formulaFuncLangMap();

// Used for preventing nested keywords matching, for example: "A LA DATE" and "DATE"
const MARKER = '__REPLACED__';

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Transform formula to user lang
export function localizeFormula(formula: string): string {
  const currentLang = getLocalStorageLocale();
  let result = formula;

  Object.keys(formulaLangMap)
    .sort((a, b) => b.length - a.length)
    .forEach(keyword => {
      const localized = formulaLangMap[keyword]?.[currentLang];
      if (localized && localized !== keyword) {
        const regex = new RegExp(`(^|[^\\w])${escapeRegex(keyword)}(?=[^\\w]|$)`, 'g');
        result = result.replace(regex, (_, prefix) => `${prefix}${MARKER}${localized}${MARKER}`);
      }
    });

  return result.replace(new RegExp(MARKER, 'g'), '');
}

// Transform formula from user lang to English which backend expects
export function deLocalizeFormula(formula: string): string {
  const currentLang = getLocalStorageLocale();
  let result = formula;

  Object.keys(formulaLangMap)
    .sort((a, b) => b.length - a.length)
    .forEach(keyword => {
      const localized = formulaLangMap[keyword]?.[currentLang];
      if (localized && localized !== keyword) {
        const regex = new RegExp(`(^|[^\\w])${escapeRegex(localized)}(?=[^\\w]|$)`, 'g');
        result = result.replace(regex, (_, prefix) => `${prefix}${MARKER}${keyword}${MARKER}`);
      }
    });

  return result.replace(new RegExp(MARKER, 'g'), '');
}

// Check if formula contains all valid keywords for specific lang. For example if user lang
// is fr and user has SUM in formula, formula is invalid because SUM is not French word
export function validateLocalizedFormula(formula: string): boolean {
  const currentLang = getLocalStorageLocale();
  let isValid = true;

  Object.keys(formulaLangMap)
    .sort((a, b) => b.length - a.length)
    .forEach(keyword => {
      const localized = formulaLangMap[keyword]?.[currentLang];
      if (localized && localized !== keyword) {
        const regex = new RegExp(`(^|[^\\w])${escapeRegex(keyword)}(?=[^\\w]|$)`, 'g');
        if (regex.test(formula)) {
          isValid = false;
        }
      }
    });

  return isValid;
}
